import { computed, type ComputedRef, type MaybeRefOrGetter, toValue } from 'vue'

/**
 * Resolves the API base path for DNS record CRUD calls. Customer routes use
 * `/domain/{id}`; admin routes use `/admin/domain/{id}`. Pass an explicit
 * `override` (typically the `apiBase` prop on a child component) to honor a
 * caller-supplied base; otherwise falls back to derivation from `isAdmin`.
 */
export function useDnsApiBase(
  domainId: MaybeRefOrGetter<number>,
  options: {
    isAdmin?: MaybeRefOrGetter<boolean | undefined>
    override?: MaybeRefOrGetter<string | undefined>
  } = {}
): ComputedRef<string> {
  return computed(() => {
    const override = toValue(options.override)
    if (override) return override
    const id = toValue(domainId)
    return toValue(options.isAdmin) ? `/admin/domain/${id}` : `/domain/${id}`
  })
}
